<template>
  <b-container fluid>
    <page-header title="Notification Settings" />
    <div class="iq-card px-3">
      <div class="iq-card-body">
        <p v-if="!visibleTabs.length" class="text-muted mb-0">
          You do not have access to any notification settings.
        </p>
        <b-tabs
          v-else
          v-model="activeIndex"
          content-class="pt-3"
        >
          <b-tab v-for="tab in visibleTabs" :key="tab.key" :title="tab.title" lazy>
            <component :is="tab.component" embedded :key="`${tab.key}-${remountSeq[tab.key]}`" />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </b-container>
</template>

<script>
import NotificationTopic from '@/views/master/notification_topic/Index.vue';
import NotificationTemplate from '@/views/master/notification_template/Index.vue';
import NotificationContact from '@/views/master/notification_contact/Index.vue';
import NotificationSubscription from '@/views/master/notification_subscription/Index.vue';
import AlertRule from '@/views/master/alert_rule/Index.vue';
import {
  NOTIFICATION_SETTINGS_TABS, visibleNotificationTabs, resolveActiveTabKey,
} from '@/util/master/notificationSettingsTabs';

const TAB_COMPONENTS = {
  topic: NotificationTopic,
  template: NotificationTemplate,
  contact: NotificationContact,
  subscription: NotificationSubscription,
  'alert-rule': AlertRule,
};

export default {
  name: 'MasterNotificationSettings',
  data() {
    // Semua key remount dideklarasiin sekarang biar reactive dari awal.
    const remountSeq = {};
    NOTIFICATION_SETTINGS_TABS.forEach((tab) => { remountSeq[tab.key] = 0; });
    return { remountSeq };
  },
  computed: {
    allowedPermissions() {
      return NOTIFICATION_SETTINGS_TABS
        .filter((tab) => this.canRead(tab.permission))
        .map((tab) => tab.permission);
    },
    visibleTabs() {
      return visibleNotificationTabs(this.allowedPermissions)
        .map((tab) => ({ ...tab, component: TAB_COMPONENTS[tab.key] }));
    },
    activeTabKey() {
      return resolveActiveTabKey(this.$route.query.tab, this.visibleTabs);
    },
    activeIndex: {
      get() {
        return this.visibleTabs.findIndex((tab) => tab.key === this.activeTabKey);
      },
      set(index) {
        const tab = this.visibleTabs[index];
        if (tab) this.setTabQuery(tab.key);
      },
    },
  },
  watch: {
    // Naikin counter tiap tab ini jadi aktif, buat maksa remount kontennya.
    activeTabKey: {
      immediate: true,
      handler(key) {
        if (!key) return;
        this.$set(this.remountSeq, key, (this.remountSeq[key] || 0) + 1);
      },
    },
  },
  methods: {
    setTabQuery(tab) {
      if (this.$route.query.tab === tab) return;
      // query lain kayak topic dibuang biar filter gak nyangkut
      this.$router.replace({ query: { tab } }).catch((err) => {
        // NavigationDuplicated wajar terjadi, jangan berisikin console.
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation')) {
          console.error(err);
        }
      });
    },
  },
};
</script>
